import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Terminalonetwothreemumbai() {



  const cardData = {


   keyword: "Terminal 1,2,3 Mumbai Airport to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Mumbai Airport Terminal 1, Terminal 2, and Terminal 3 to Pune cab services with safe, comfortable, and affordable airport transportation for business travelers, corporate executives, families, tourists, and outstation passengers. Whether you arrive at the domestic or international terminal, our professional chauffeurs ensure timely airport pickups, flight tracking support, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, meet-and-greet airport pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mumbai Airport Terminal 1, 2 & 3 to Pune taxi services.",

  topPlaces: [
    {
      title: "Viman Nagar",
      description: "Viman Nagar is one of Pune's most popular business and residential destinations, located close to Pune Airport. It is known for IT companies, shopping malls, hotels, restaurants, and excellent connectivity, making it a preferred location for airport travelers."
    },
    {
      title: "Koregaon Park",
      description: "Koregaon Park is a premium locality featuring luxury hotels, cafés, restaurants, corporate offices, and entertainment venues. It is one of Pune's most visited destinations for business travelers and tourists."
    },
    {
      title: "Hadapsar",
      description: "Hadapsar is a major commercial hub known for Magarpatta City, business parks, IT companies, educational institutions, and excellent road connectivity. It is a preferred destination for professionals and corporate travelers."
    },
    {
      title: "Baner",
      description: "Baner is a fast-growing commercial and residential area offering IT offices, business centers, premium restaurants, educational institutions, and modern residential projects."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is one of Maharashtra's largest industrial and commercial regions, home to automobile manufacturers, engineering companies, corporate offices, and modern infrastructure."
    },
    {
      title: "Chakan MIDC",
      description: "Chakan MIDC is a leading industrial corridor with automobile companies, engineering industries, logistics hubs, and manufacturing units. It is an important destination for industrial and business travel."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is Pune's iconic historical monument, admired for its magnificent Maratha architecture, cultural significance, and evening light-and-sound show. It is one of the city's top tourist attractions."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "Raja Dinkar Kelkar Museum houses an exceptional collection of Indian art, antiques, sculptures, traditional musical instruments, and historical artifacts. It is a must-visit destination for culture and history enthusiasts."
    },
    {
      title: "Lavasa",
      description: "Lavasa is a scenic planned hill city near Pune, famous for its lakeside promenade, colorful architecture, adventure activities, and peaceful surroundings. It is a popular weekend getaway for families and couples."
    },
    {
      title: "Bhimashankar Wildlife Sanctuary",
      description: "Bhimashankar Wildlife Sanctuary is a beautiful nature destination known for dense forests, wildlife, trekking trails, waterfalls, and the famous Bhimashankar Temple. It is a favorite getaway for nature lovers and adventure enthusiasts."
    }
  ],






"services": [
  {
    "name": "Mumbai Airport Terminal 1 to Pune Cab Fare",
    "description": "Check Mumbai Airport Terminal 1 to Pune Cab Fare with transparent pricing, fixed rates, professional chauffeurs, AC vehicles, doorstep pickup, luggage assistance, and comfortable travel for business, family, and airport transfer needs."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Pune Cab",
    "description": "Book Mumbai Airport Terminal 2 to Pune Cab with clean AC cars, experienced drivers, fixed fares, instant confirmation, and reliable airport pickup available 24x7."
  },
  {
    "name": "Mumbai Airport Terminal 3 to Pune Cab",
    "description": "Reserve Mumbai Airport Terminal 3 to Pune Cab for comfortable airport transfers with Sedan, Ertiga, Innova Crysta, SUV, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai Domestic Airport Terminal 1 to Pune Cab",
    "description": "Travel from Mumbai Domestic Airport Terminal 1 to Pune with punctual pickup, affordable pricing, spacious luggage space, and safe highway travel."
  },
  {
    "name": "Mumbai Domestic Airport Cab",
    "description": "Hire Mumbai Domestic Airport Cab for reliable airport pickup and drop with professional drivers, sanitized vehicles, and 24x7 customer support."
  },
  {
    "name": "Mumbai International Airport Taxi",
    "description": "Book Mumbai International Airport Taxi with fixed fares, premium AC vehicles, experienced chauffeurs, and dependable airport transfer services."
  },
  {
    "name": "24x7 Mumbai Airport Cab Booking",
    "description": "Reserve 24x7 Mumbai Airport Cab Booking anytime with instant confirmation, online booking, multiple vehicle choices, and professional airport transportation."
  },
  {
    "name": "Mumbai Airport Outstation Taxi",
    "description": "Choose Mumbai Airport Outstation Taxi for long-distance travel with comfortable AC vehicles, transparent pricing, and experienced drivers."
  },
  {
    "name": "Mumbai Airport Innova Cabs",
    "description": "Book Mumbai Airport Innova Cabs for spacious family travel, corporate transfers, group journeys, and comfortable airport transportation."
  },
  {
    "name": "Mumbai Airport Ertiga Taxi",
    "description": "Hire Mumbai Airport Ertiga Taxi for affordable six-seater airport travel with professional chauffeurs and comfortable seating."
  },
  {
    "name": "Mumbai Airport Sedan Cab Service",
    "description": "Travel with Mumbai Airport Sedan Cab Service offering economical fares, clean AC cars, punctual pickup, and smooth airport transfers."
  },
  {
    "name": "Mumbai Airport Terminal 2 Taxi Service",
    "description": "Book Mumbai Airport Terminal 2 Taxi Service with fixed pricing, experienced drivers, and reliable pickup for domestic and international travelers."
  },
  {
    "name": "Transport Facility at Mumbai Airport",
    "description": "Choose reliable Transport Facility at Mumbai Airport with private cabs, chauffeur-driven vehicles, airport pickup, and intercity travel options."
  },
  {
    "name": "Book Airport Services Online",
    "description": "Book Airport Services Online with instant confirmation, secure reservations, multiple vehicle options, and 24x7 customer assistance."
  },
  {
    "name": "Book Airport Services Online India",
    "description": "Reserve Airport Services Online India for airport transfers, intercity travel, chauffeur-driven cars, and hassle-free transportation."
  },
  {
    "name": "Book Mumbai Airport Services Online",
    "description": "Book Mumbai Airport Services Online for quick reservations, professional drivers, transparent pricing, and premium airport cab services."
  },
  {
    "name": "Book Mumbai Airport Services Online Terminal 1",
    "description": "Reserve Mumbai Airport Terminal 1 cab services online with instant booking, fixed fares, and comfortable airport transportation."
  },
  {
    "name": "Mumbai Airport to Pune Cab",
    "description": "Book Mumbai Airport to Pune Cab with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for safe, reliable, and comfortable intercity travel."
  },
  {
    "name": "Mumbai Airport to Pune Taxi",
    "description": "Travel from Mumbai Airport to Pune Taxi with professional chauffeurs, transparent pricing, clean AC vehicles, and convenient doorstep drop."
  },
  {
    "name": "Mumbai Airport to Pune Cab Service",
    "description": "Our Mumbai Airport to Pune Cab Service offers fixed fares, timely airport pickup, experienced drivers, and premium customer support."
  },
  {
    "name": "Mumbai Airport to Pune One Way Cab",
    "description": "Choose Mumbai Airport to Pune One Way Cab for direct travel with affordable fares, comfortable vehicles, and reliable service."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Booking",
    "description": "Complete Mumbai Airport to Pune Taxi Booking online with instant confirmation, multiple cab options, and secure reservations."
  },
  {
    "name": "Mumbai Airport to Pune Drop Taxi",
    "description": "Book Mumbai Airport to Pune Drop Taxi with professional drivers, fixed pricing, luggage assistance, and smooth highway travel."
  },
  {
    "name": "Mumbai Airport to Pune Online Cab Booking",
    "description": "Reserve Mumbai Airport to Pune Online Cab Booking for quick confirmation, transparent fares, and 24x7 availability."
  },
  {
    "name": "T1 Mumbai Airport to Pune Cab",
    "description": "Book T1 Mumbai Airport to Pune Cab with punctual pickup, clean AC vehicles, and experienced chauffeurs for comfortable travel."
  },
  {
    "name": "T2 Mumbai Airport to Pune Cab",
    "description": "Choose T2 Mumbai Airport to Pune Cab for reliable airport transfers with fixed fares, premium vehicles, and professional drivers."
  },
  {
    "name": "T3 Mumbai Airport to Pune Cab",
    "description": "Reserve T3 Mumbai Airport to Pune Cab with spacious vehicles, timely pickup, transparent pricing, and safe intercity travel."
  },
  {
    "name": "Mumbai Airport Terminal 1 to Pune Cab",
    "description": "Hire Mumbai Airport Terminal 1 to Pune Cab for comfortable chauffeur-driven airport transportation with affordable pricing."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Pune Cab",
    "description": "Book Mumbai Airport Terminal 2 to Pune Cab with AC vehicles, experienced chauffeurs, luggage support, and fixed fares."
  },
  {
    "name": "Mumbai Airport Terminal 3 to Pune Cab",
    "description": "Travel from Mumbai Airport Terminal 3 to Pune Cab with premium vehicles, reliable pickup, and professional drivers."
  },
  {
    "name": "Mumbai Airport to Pune Innova Cab",
    "description": "Reserve Mumbai Airport to Pune Innova Cab for family travel, business trips, group transfers, and spacious airport transportation."
  },
  {
    "name": "Mumbai Airport to Pune AC Taxi Service",
    "description": "Choose Mumbai Airport to Pune AC Taxi Service with clean air-conditioned vehicles, affordable fares, and dependable drivers."
  },
  {
    "name": "Mumbai Airport to Pune Airport Transfer Cab",
    "description": "Book Mumbai Airport to Pune Airport Transfer Cab for seamless airport pickup, comfortable travel, and on-time destination drop."
  },
  {
    "name": "Mumbai Airport to Pune Private Cab Booking",
    "description": "Reserve Mumbai Airport to Pune Private Cab Booking for exclusive chauffeur-driven travel with flexible timing and premium comfort."
  },
  {
    "name": "Mumbai Airport to Pune Cab Per Km Rate",
    "description": "Check Mumbai Airport to Pune Cab Per Km Rate with transparent pricing, fixed packages, and multiple vehicle options."
  },
  {
    "name": "Mumbai Airport to Pune Innova Crysta Taxi",
    "description": "Book Mumbai Airport to Pune Innova Crysta Taxi for luxury airport travel with spacious seating, luggage capacity, and premium comfort."
  },
  {
    "name": "Mumbai Airport to Pune 24×7 Airport Cab Service",
    "description": "Choose Mumbai Airport to Pune 24×7 Airport Cab Service for round-the-clock airport transfers, professional chauffeurs, fixed pricing, and reliable customer support."
  }
],

"tableData": [
  ["Mumbai Airport Terminal 1 to Pune Cab Fare", "Mumbai Airport Terminal 2 to Pune Cab"],
  ["Mumbai Airport Terminal 3 to Pune Cab", "Mumbai Domestic Airport Terminal 1 to Pune Cab"],
  ["Mumbai Domestic Airport Cab", "Mumbai International Airport Taxi"],
  ["24x7 Mumbai Airport Cab Booking", "Mumbai Airport Outstation Taxi"],
  ["Mumbai Airport Innova Cabs", "Mumbai Airport Ertiga Taxi"],
  ["Mumbai Airport Sedan Cab Service", "Mumbai Airport Terminal 2 Taxi Service"],
  ["Transport Facility at Mumbai Airport", "Book Airport Services Online"],
  ["Book Airport Services Online India", "Book Mumbai Airport Services Online"],
  ["Book Mumbai Airport Services Online Terminal 1", "Mumbai Airport to Pune Cab"],
  ["Mumbai Airport to Pune Taxi", "Mumbai Airport to Pune Cab Service"],
  ["Mumbai Airport to Pune One Way Cab", "Mumbai Airport to Pune Taxi Booking"],
  ["Mumbai Airport to Pune Drop Taxi", "Mumbai Airport to Pune Online Cab Booking"],
  ["T1 Mumbai Airport to Pune Cab", "T2 Mumbai Airport to Pune Cab"],
  ["T3 Mumbai Airport to Pune Cab", "Mumbai Airport Terminal 1 to Pune Cab"],
  ["Mumbai Airport Terminal 2 to Pune Cab", "Mumbai Airport Terminal 3 to Pune Cab"],
  ["Mumbai Airport to Pune Innova Cab", "Mumbai Airport to Pune AC Taxi Service"],
  ["Mumbai Airport to Pune Airport Transfer Cab", "Mumbai Airport to Pune Private Cab Booking"],
  ["Mumbai Airport to Pune Cab Per Km Rate", "Mumbai Airport to Pune Innova Crysta Taxi"],
  ["Mumbai Airport to Pune 24×7 Airport Cab Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Terminal 1, 2 & 3 Mumbai Airport to Pune Cab",
    WhyChoosedescription: "Trustline Cab offers dependable cab services from Mumbai Airport Terminal 1, Terminal 2, and nearby airport locations to Pune with comfortable vehicles and experienced drivers."
  },
  {
    WhyChooseheading: "Convenient Airport Pickup Service",
    WhyChoosedescription: "Enjoy hassle-free pickup from Mumbai Airport arrival terminals with direct drop to your home, hotel, office, or any destination across Pune."
  },
  {
    WhyChooseheading: "Flight-Based Pickup Coordination",
    WhyChoosedescription: "Our team schedules your cab according to your flight arrival time, ensuring timely pickup and a smooth airport transfer experience."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Safe Travel",
    WhyChoosedescription: "Experienced drivers ensure safe, comfortable, and efficient travel from Mumbai Airport to Pune using the best available routes."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Receive clear fare details before booking with competitive pricing and no hidden charges for your airport transfer."
  },
  {
    WhyChooseheading: "Suitable for Business & Family Travel",
    WhyChoosedescription: "Our airport cab service is ideal for corporate executives, tourists, families, students, and individual travelers visiting Pune."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Booking",
    WhyChoosedescription: "Book your Mumbai Airport to Pune cab anytime with round-the-clock customer support and instant booking confirmation."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mumbai Airport Terminal 1, 2 & 3 to Pune cab service?",
    answer: "Yes, Trustline Cab provides reliable airport cab services from Mumbai Airport Terminal 1, Terminal 2, and nearby airport areas to Pune."
  },
  {
    question: "Can I book a one-way cab from Mumbai Airport to Pune?",
    answer: "Yes, one-way airport transfer cabs are available with direct pickup from Mumbai Airport and drop anywhere in Pune."
  },
  {
    question: "Will the driver arrive according to my flight timing?",
    answer: "Yes, pickup is coordinated based on your flight arrival schedule to provide a convenient airport transfer."
  },
  {
    question: "Which vehicles are available for Mumbai Airport to Pune travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to passenger and luggage requirements."
  },
  {
    question: "Is airport cab service available throughout the day?",
    answer: "Yes, our Mumbai Airport to Pune cab service operates 24/7, including early morning and late-night flight pickups."
  },
  {
    question: "Can I book a return cab from Pune to Mumbai Airport?",
    answer: "Yes, round-trip and return airport transfer services are available for passengers traveling back to Mumbai Airport."
  },
  {
    question: "Are toll and airport parking charges included in the fare?",
    answer: "Toll charges, airport parking fees, and applicable taxes are generally charged separately unless mentioned in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my airport cab in advance?",
    answer: "Yes, advance booking is recommended to ensure timely pickup and availability of your preferred vehicle."
  },
  {
    question: "Do you provide airport transfers for corporate travelers?",
    answer: "Yes, our airport cab services are ideal for business executives, corporate clients, tourists, and family travelers."
  },
  {
    question: "How can I book Mumbai Airport Terminal 1, 2 & 3 to Pune Cab with Trustline Travels?",
    answer: "Share your flight details, arrival terminal, Pune destination, travel date, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Choudhary",
    feedback: "The airport pickup was perfectly coordinated with our flight arrival. The driver was punctual, the vehicle was spotless, and the journey from Mumbai Airport to Pune was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Richa Deshpande",
    feedback: "Trustline Travels made our airport transfer effortless with quick communication, a professional chauffeur, and a clean, comfortable cab. The complete trip to Pune was smooth and relaxing.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Terminal 1, 2, 3 Mumbai Airport to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/terminal-1-2-3-mumbai-airport-to-pune-cab.webp",
  "description":
    "Book Terminal 1, 2, 3 Mumbai Airport to Pune Cab with Trustline Travels for safe, comfortable, and affordable airport taxi services. We provide 24x7 cab services from Mumbai Airport Terminal 1, Terminal 2, and Terminal 3 to Pune and all major locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available for one-way and round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/terminal-1-2-3-mumbai-airport-to-pune-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Terminal 1, 2, 3 Mumbai Airport to Pune Cab | Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Terminal 1, 2, 3 Mumbai Airport to Pune Cab with Trustline Travels for reliable airport transfers. Get 24x7 taxi services from Mumbai Airport Terminal 1, Terminal 2, Terminal 3, domestic and international airport to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs."
  />

  <meta
    name="keywords"
    content="mumbai airport terminal 1 to pune cab fare, mumbai airport terminal 2 to pune cab, mumbai airport terminal 3 to pune cab, mumbai domestic airport terminal 1 to pune cab, mumbai domestic airport cab, mumbai international airport taxi, 24x7 mumbai airport cab booking, mumbai airport outstation taxi, Terminal 1 2 3 Mumbai Airport to Pune Cab, Mumbai Airport to Pune Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Terminalonetwothreemumbai;